import React, { useCallback } from "react";
import FileBrowser from "./FileBrowser";
import SharePointService from "../../../service/sharePointService";
import { useParams } from "react-router-dom";

export default function SharePointBrowser(props) {
  const { Workspace_id } = useParams();

  let { url, path, docuList, multipleFileSelection } = props;

  let pref = "";
  let fileName = multipleFileSelection ? [] : "";

  if (path !== "/") {
    if (multipleFileSelection) {
      const tempPathArr = [];

      path.split(",/").forEach((path, key) => {
        //Adding or removing extra '/' and making complete prefix

        if (path !== "/") {
          const tPathArray = path.split("/");
          fileName.push(tPathArray.pop());
          if (!path.endsWith("/")) path = path.replace(fileName[key], "");

          if (key === 0 && path !== "/") {
            if (pref) {
              if (pref.endsWith("/")) pref = pref + path.substring(1);
              else pref = pref + path;
            } else {
              if (path.startsWith("/")) pref = path.substring(1);
              else pref = "/" + path;
            }
          }
          tempPathArr.push(key === 0 ? path : "/" + path);
        }
      });

      // Check is files are selected from more than one folders then Browser will open with default container
      let uniquepathArr = [...new Set(tempPathArr)];
      if (uniquepathArr.length > 1) pref = props.defaultPath;
    } else {
      const tPathArray = path.split("/");
      fileName = tPathArray.pop();

      if (!path.endsWith("/")) path = path.replace(fileName, "");

      if (pref.endsWith("/")) pref = pref + path.substring(1);
      else pref = pref + path;
    }
  }

  //Getting file and folder data
  const getData = useCallback(async ({ prefix, Stage_id, ...params }) => {
    const sharepoint = new SharePointService();
    return await sharepoint.getData({ prefix, Stage_id, ...params });
  }, []);

  //Download click
  const downloadClick = async ({ name, fileName, Stage_id }) => {
    const sharepoint = new SharePointService();
    await sharepoint.download(Workspace_id, {
      name,
      fileName,
      Stage_id,
    });
  };

  //Download button click
  const multipleDownload = async ({ name, files, Stage_id }) => {
    const sharepoint = new SharePointService();
    await sharepoint.download(Workspace_id, {
      name,
      Stage_id,
      files,
    });
  };

  //Delete click
  const deleteClick = async ({ name, Stage_id }) => {
    const sharepoint = new SharePointService();
    return await sharepoint.delete({
      name,
      Stage_id,
    });
  };

  //Delete Button click (Multiple files)
  const multipleDelete = async ({ name, Stage_id, type, files }) => {
    const sharepoint = new SharePointService();
    return await sharepoint.delete({
      name,
      Stage_id,
      type,
      files,
    });
  };

  //Create Folder
  const manageObjectClick = async ({ name, Stage_id, oldKey, objType }) => {
    const sharepoint = new SharePointService();
    return await sharepoint.manageObject({
      name,
      Stage_id,
      oldKey,
      objType,
    });
  };

  return (
    <FileBrowser
      {...props}
      getData={getData}
      createFolderClick={manageObjectClick}
      deleteClick={deleteClick}
      multipleDownload={multipleDownload}
      multipleDelete={multipleDelete}
      downloadClick={downloadClick}
      pref={!pref.startsWith("/") ? "/" + pref : pref}
      fileName={multipleFileSelection ? fileName.join(",/") : fileName}
      url={url}
      docuList={docuList}
      title="SharePoint Explorer"
      type="sharepoint"
    />
  );
}
